import { Component, Input, Output, EventEmitter } from '@angular/core';
import { environment } from '@environments/environment';
import { IntlService } from '@progress/kendo-angular-intl';
import { BaseInfoComponent } from "./base-info.component";
import { DatasourceService } from '@app/core/services';
import { Router } from '@angular/router';
import * as moment from 'moment'


@Component({
  selector: 'diario-info',
  styleUrls: ['./styles/styles-info.css'],
  styles: [`
    .card {
      height: auto;
      border: rgba(0, 0, 0, 0.08) 1px solid;
    }
    .card-details {
      width: 75%;
    }
    .card-status {
      text-align: center;
      padding-bottom: 12px;
    }
    .card-status > div {
      color: white; 
      background-size: contain; 
      padding: 4px; 
      text-align: center; 
    }
    .card-status > img {
      width: 48px;
    }
    .k-block {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 80px;
      border-color: transparent;
    }
    .section-title {
      padding-top: 8px;
      padding-bottom: 4px;
    }
    .section-payment {
      background-color: #ecf0f1;
      display: block;
      width: 100% !important;
      padding: 4px 0;
      text-align: center;
      margin-top: 4px;
      min-height: 18px;
    }
    .section-separator {
      background-color: #ecf0f1;
      display: block;
      width: 100% !important;
      margin: 8px 0;
      min-height: 1px;
    }
  `],
  template: `
    <!--{{customer | json}}-->
    <div class="k-block" *ngIf="loading">
      <kendo-loader [type]="'pulsing'" [size]="'medium'"></kendo-loader>
    </div>
    <div class="card" *ngIf="!loading">
      <div class="card-details">
        
        <div class="section-payment">
          <label class="k-label">EFECTIVO:</label>
        </div>
        <div class="section-title">
          <label class="k-label">Ingresos:</label> <span class="right">{{ intl.formatNumber(data.total.efectivo.incomes, "c2") }}</span>
        </div>
        <div class="section-title">
          <label class="k-label">Egresos:</label> <span class="right text-danger">{{ intl.formatNumber(-data.total.efectivo.expenses, "c2") }}</span>
        </div>
        <div class="section-separator"></div>
        <div class="section-title">
          <label class="k-label">Subtotal:</label> <span class="right  {{data.total.efectivo.total < 0 ? 'text-danger': ''}}" style="font-size: 20px;" >{{ intl.formatNumber(data.total.efectivo.total, "c2") }}</span>
        </div>

        <div class="section-payment">
          <label class="k-label">TRANSFERENCIA Y TARJETA</label>
        </div>
        <div class="section-title">
          <label class="k-label">Ingresos:</label> <span class="right">{{ intl.formatNumber(data.total.other.incomes, "c2") }}</span>
        </div>
        <div class="section-title">
          <label class="k-label">Egresos:</label> <span class="right text-danger">{{ intl.formatNumber(-data.total.other.expenses, "c2") }}</span>
        </div>
        <div class="section-separator"></div>
        <div class="section-title">
          <label class="k-label">Subtotal:</label> <span class="right {{data.total.other.total < 0 ? 'text-danger': ''}}" style="font-size: 20px;">{{ intl.formatNumber(data.total.other.total, "c2") }}</span>
        </div>

        <div class="section-separator"></div>

        <div class="section-title">
          <span class="right {{data.total.sum < 0 ? 'text-danger': ''}}" style="font-size: 24px; font-weight: bold;">Total: {{ intl.formatNumber(data.total.sum, "c2") }}</span>
        </div>
        
      </div>            
    </div>  
  `,    
})
export class DiarioInfoComponent extends BaseInfoComponent {

  //Input: id
  @Input() data : any = 0;  

  @Input() loading : Boolean = true;  

  @Output() complete = new EventEmitter<{dataItem: any}>();


  constructor(public intl: IntlService, public router: Router, protected service: DatasourceService) { 

    super(intl, router)

  }  

}